// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3332":"7f136d19eec4f5f1","5285":"e8735b7b724ae66f"}[chunkId] + ".css";
};